import { HeaderCommonProps } from "@components/Header/types";
import useIsAppWebView from "@hooks/useIsAppWebView";
import MyAccountHeaderFactoryAnonTriger from "@routes/MyAccount/components/MyAccountHeader/MyAccountHeaderFactoryAnonTrigger";
import { cn } from "@util/helpers";

export default function MyAccountAnonTrigger({
  textClassName,
}: Pick<HeaderCommonProps, "textClassName">): React.ReactElement {
  const isAppWebView = useIsAppWebView();

  if (isAppWebView) return <></>;

  return (
    <div
      className="relative flex-none"
      data-testid="my-account-header-anon-trigger-component"
      id="my-account-anon-trigger"
    >
      <div className={cn("relative z-10")}>
        <MyAccountHeaderFactoryAnonTriger textClassName={textClassName} />
      </div>
    </div>
  );
}
